/* eslint-disable react/forbid-prop-types,import/prefer-default-export */
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { isIOS } from 'react-device-detect';
import Input from '../../../../components/Input';
import { clearFormError, handleFormBlur } from '../../../../utilities/formsUtils';
import { OnboardingBodyLayout } from '../partials';

export const ConfirmPasswordRequestEmailComponent = ({
  form,
  handleSubmit,
  resendResetPasswordEmail,
  renderButtons,
  handleChange,
  timer,
  isResetPasswordRequested,
}) => {
  const { t: translate } = useTranslation();
  const history = useHistory();

  return (
    <OnboardingBodyLayout
      title={translate('email_verification_title')}
      renderButtons={renderButtons}
      withBack
      onPrevClick={history.goBack}>
      <p className="text-f5 text-dark mt-4">
        {translate('email_verification_reset_password_subtitle')}
      </p>
      <form onSubmit={handleSubmit} id="email-confirmation">
        <Input
          subLabel={`${translate('email_verification_message_label')} ${timer} ${translate(
            'email_verification_subtext_label_sec'
          )}`}
          value={form.code}
          groupClassName={`mb-0 mt-4 ${isIOS ? 'ios' : ''}`}
          className={`${isIOS ? 'ios' : ''}`}
          name="code"
          type="number"
          onChange={handleChange}
          onBlur={handleFormBlur}
          onFocus={clearFormError}
          actionLabel={translate('resend_button_label')}
          actionClick={resendResetPasswordEmail}
          actionDisabled={timer > 0 || isResetPasswordRequested}
          placeholder={translate('email_verification_input_label')}
          label={translate('email_verification_input_label')}
          errorLabel={translate('verification_code_error_label')}
          autoComplete="off"
          actionBtnTop="18%"
          withFloatingLabel
          withSubLabel
          withErrorLabel
        />
      </form>
    </OnboardingBodyLayout>
  );
};

ConfirmPasswordRequestEmailComponent.propTypes = {
  form: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  resendResetPasswordEmail: PropTypes.func.isRequired,
  renderButtons: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  timer: PropTypes.number.isRequired,
  isResetPasswordRequested: PropTypes.bool.isRequired,
};
